import { notification } from "antd";
import { useCallback } from "react";
import { SubmitHandler } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  useActionUploadAttachmentsMutation,
  useActionPerformedMutation,
} from "../../../features/api/apiSlice";
import { FormMarkAsPerformedPostValues } from "../../../types/actions";
import { formatDayJSToDateString } from "../../../utils/dates";
import { getErrorMessage } from "../../../utils/errors/errors";
import { FormMarkAsPerformedSchema } from "./FormMarkAsPerformed";

export default function useSubmitMarkAsPerformed({
  id: actionId,
  onSuccess,
}: {
  id: number;
  onSuccess: () => void;
}) {
  const navigate = useNavigate();

  const [actionPerformed, { isLoading: isMarkingActionPerformed }] =
    useActionPerformedMutation();

  const [postAttachments, { isLoading: isPostingAttachments }] =
    useActionUploadAttachmentsMutation();

  const onSubmit: SubmitHandler<FormMarkAsPerformedSchema> = useCallback(
    async (values) => {
      try {
        const formattedValues: FormMarkAsPerformedPostValues = {
          ...values,
          actionId,
          dateDone: formatDayJSToDateString(values.dateDone),
          attachedFiles: undefined, // Files are uploaded spearatlly (see below)
        };
        console.log("values", values);
        console.log("Formatted Values", formattedValues);

        // 1) "Ask validation" request
        const askPayload = await actionPerformed(formattedValues).unwrap();
        console.log("Response actionPerformed", askPayload);

        // Show success notification
        notification.success({
          message: "L'action a Ã©tÃ© correctement marquÃ©e comme rÃ©alisÃ©e",
        });

        // 2) Upload attachments (linked to actions)
        const files: undefined | File[] = values?.attachedFiles;

        if (files?.length) {
          const responseUpload = await postAttachments({
            actionId,
            files,
          }).unwrap();
          console.log("Response Upload", responseUpload);
          // Show success notification
          notification.success({
            message: "PiÃ¨ces jointes ajoutÃ©es",
          });
        }

        onSuccess();
      } catch (error) {
        console.error("Error actionPerformed", error);
        notification.error({
          message: "Erreur",
          description: getErrorMessage(error),
        });
      }
    },
    [actionId, actionPerformed, onSuccess, postAttachments],
  );

  return {
    onSubmit,
    isLoading: isMarkingActionPerformed || isPostingAttachments,
  };
}
